/**
 * Scroll a section into view beneath the sticky nav.
 *
 * Uses an explicit window.scrollTo rather than element.scrollIntoView, which
 * picks its own scroll container and under-scrolls here.
 */
export default function scrollToSection(id, { behavior = 'smooth' } = {}) {
  const el = document.getElementById(id);
  if (!el) return;

  const navH =
    parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nav-h')) || 64;

  const top = el.getBoundingClientRect().top + window.scrollY - (navH + 16);
  window.scrollTo({ top: Math.max(0, top), behavior });
}
